export const CountNotification = ({ totalCount }: { totalCount?: number }) => {
  return (
    <span className="inline-block font-bold rounded bg-primary-500 text-xxs text-white px-1">
      {totalCount}
    </span>
  );
};
